import React, { useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiIcon, EuiButtonIcon} from '@elastic/eui';
import { useLanguage } from '../../../../../shared/hooks/Language';


export const Formulario = (props)=>{

  const {translate} = useLanguage();

  let {onLogin} = props
  let [user,setUser] = useState(undefined)
  let [password,setPassword] = useState(undefined)
  let [loading, setLoading] = useState(false) 
  let [viewPass, setViewPass] = useState(false)

  const onSaveData = async() =>{
    if(!comprobarErrores()){
      setLoading(true)
      let res = await (onLogin && onLogin(user, password))
      if(!res){
        setLoading(false)
      }
    }
  }

  const onPressLogin = (key) =>{
    if(!comprobarErrores() && key==='Enter'){
      onSaveData();
    }
  }

  const isInvalidUser = () => {return user===undefined || user.trim()===""}
  
  const isInvalidPassword = () => {return password===undefined || password.trim()===""}

  const comprobarErrores = () => {
    return (isInvalidUser() || isInvalidPassword())
  }


  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow label={translate('usuario')} fullWidth>
          <EuiFieldText autoComplete='username' fullWidth value={user} name="txtUser" onChange={e => setUser(e.target.value)} isInvalid={isInvalidUser()} autoFocus
          prepend={<EuiIcon className={isInvalidUser()? "invalidUserIcon" : "validUserIcon"} type="user" />}
          />
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow label={translate('contraseña')} fullWidth>
          <EuiFieldText autoComplete='current-password' type={viewPass ? "text" : "password"} fullWidth value={password} name="txtPassword" onChange={e => setPassword(e.target.value)} isInvalid={isInvalidPassword()}
          onKeyPress={event => onPressLogin(event.key) }
          prepend={<EuiIcon 
          className={isInvalidPassword()? "invalidPasswordIcon" : "validPasswordIcon"} 
          type={isInvalidPassword() ? "lock" : "lockOpen"}/>}

          append={
            <EuiButtonIcon
            aria-label=""
            title=""
            iconType={viewPass ? "eyeClosed" : "eye"}
            color='subdued'
            onClick={()=> setViewPass(!viewPass)}
            />
          }
          />
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    <EuiSpacer size="l" />

    <EuiFlexGroup>
      <EuiFlexItem fullWidth>
        <EuiButton fullWidth onClick={onSaveData} disabled={false} isLoading={loading}>
          {loading ? "Validando" : "Login"}
        </EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
  )
}
export default Formulario;